import type { ICustomerGetMyCardsListReqQuery, ICustomerGetMyCardsListResBody } from '@/api/user.d'

import fetch from '@/utils/fetch'

/**
 * 判断用户是否有支付密码
 * @param params
 * @returns
 */
export function hasPayPwd(params = {}) {
  return fetch('/customer/hasPayPwd', { params })
}

/**
 * 验证密码
 * @param params
 * @returns
 */
export function checkPayPassword(params) {
  return fetch('/customer/checkUserPayPasswordPwd', {
    params,
    isToastErr: false,
  })
}

/**
 * 修改支付密码
 * @param params
 * @returns
 */
export function updatePayPwd(params) {
  return fetch('/customer/updatePayPasswordPwd', {
    params,
  })
}

/**
 * 查询我的卡列表
 * @param params
 * @returns
 */
export function queryCardList(
  params?: ICustomerGetMyCardsListReqQuery,
): Promise<ICustomerGetMyCardsListResBody> {
  return fetch('/customer/getMyCardsList', {
    params,
  })
}

/**
 * 查询客户是否绑卡
 * @param params
 * @returns
 */
export function getCardBindStatus() {
  return fetch('/customer/getCardBindStatus')
}

/**
 * 如果用户已绑卡 查询用户所有绑卡渠道号
 * @returns
 */
export function getMyBankNo() {
  return fetch('/customer/getMyBankNo')
}

/**
 * 判断用户是否有身份证号信息
 * @param params
 * @returns
 */
export function hasIdNo() {
  return fetch('/customer/hasIdNo')
}

/**
 * 小程序获取secKey
 * @param params
 * @returns
 */
export function validateLoginSms(params) {
  return fetch('/customerV2/saveSec', {
    params,
  })
}

// http://yapi.miguatech.com/project/22/interface/api/61107
// 获取用户appId 和 loginStr
export function getLifepayLoginStr(params) {
  return fetch(
    '/aomi-payservice/cashierOpen/getLifepayLoginStr',
    {
      params,
    },
    'base',
  )
}

export function loginLifePay(params) {
  return fetch('/customer/aomiRegiterOrLogin', {
    params,
  })
}
